/** 도매 주문 — 서버 `schemas/types/main/WholesaleType.ts` 와 같은 모양 (DISPATCH_PLAN §5) */
export type WholesaleCurrency = 'USD' | 'KRW'

export interface WholesaleReceiverType {
	givenName: string
	familyName: string
	phoneCountryCode: string
	phoneNumber: string
	street1: string
	street2: string
	city: string
	stateName: string
	stateIsoCode: string
	zip: string
	countryName: string
	countryIsoCode: string
}

export interface WholesaleCatalogItemType {
	productId: string
	seasonProductId: string
	code: string
	name: string
	unitAmount: number
	unitUsd: number
	ruleLabel: string
}

export interface WholesaleCatalogType {
	customerId: string
	companyName: string
	currency: WholesaleCurrency
	vatExtraYn: number
	shippingExtraYn: number
	dutyExtraYn: number
	seasonId: string
	items: WholesaleCatalogItemType[]
	lastReceiver: WholesaleReceiverType | null
}

export interface WholesaleQuoteLineType extends WholesaleCatalogItemType {
	qty: number
	lineAmount: number
	lineUsd: number
}

export interface WholesaleQuoteProblemType {
	code: string
	message: string
	productId?: string
	expected?: number
	seen?: number
}

export interface WholesaleQuoteType {
	ok: boolean
	customerId: string
	currency: WholesaleCurrency
	seasonId: string
	lines: WholesaleQuoteLineType[]
	subtotalAmount: number
	subtotalUsd: number
	vatAmount: number
	shippingAmount: number
	dutyAmount: number
	paidAmount: number
	problems: WholesaleQuoteProblemType[]
}

export interface WholesaleOrderReqType {
	items: { productId: string; qty: number }[]
	receiver: WholesaleReceiverType
	shippingAmount?: number
	dutyAmount?: number
	memo?: string
}

export const emptyWholesaleReceiver = (): WholesaleReceiverType => ({
	givenName: '',
	familyName: '',
	phoneCountryCode: '',
	phoneNumber: '',
	street1: '',
	street2: '',
	city: '',
	stateName: '',
	stateIsoCode: '',
	zip: '',
	countryName: '',
	countryIsoCode: '',
})
